export enum UserType {
    Unknown = 'Unknown',
    Professional = 'Professional',
    Customer = 'Customer',
}

export default UserType;